import { combineReducers } from "redux";

import { bookingSettingDetails } from "./reducer.bookingSetting"
const bookingSettingReducers = combineReducers({
  bookingSettingDetails
})
export default bookingSettingReducers;
